import { useState } from "react";
import Button, { ButtonModeE } from "../../components/Button/Button";
import ContactUsForm from "../../components/ContactUsForm/ContactUsForm";
import { P } from "../../components/Text/Text";
import { reqCheck } from "../../assets/images";

import styles from "./contactUsPublic.module.scss";

const ContactUsPublic = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value: string | null) => {
    setIsCaptchaVerified(!!value);
  };

  return (
    <main className={styles.mainWrapper}>
      <div>
        <h1>Let's Chat</h1>
        <p>
          Looking for some peace of mind? Let us show you how JumboMedia will
          make your work easier. Fill in the form and we'll get back to you as
          soon as possible.
        </p>
        <div className={styles.bodyWrapper}>
          {isSubmitted ? (
            <div className={styles.successSection}>
              <img src={reqCheck} alt="success" />
              <P>
                Your message has been sent successfully. We will get back to you
                as soon as possible.
              </P>
              <Button
                onClick={() => setIsSubmitted(false)}
                mode={ButtonModeE.OUTLINED}
              >
                Send more
              </Button>
            </div>
          ) : (
            <div className={styles.formSection}>
              <ContactUsForm
                setIsSubmitting={setIsSubmitting}
                setIsSubmitted={setIsSubmitted}
              />
              {/* <div className={styles.captchaWrapper}>
                            <ReCAPTCHA
                                sitekey="Your client site key"
                                onChange={handleCaptchaChange}
                            />
                        </div> */}
              <Button
                form="public-contact-form"
                loading={isSubmitting}
                disabled={isSubmitting}
              >
                Submit
              </Button>
            </div>
          )}
          {/* <img src={microphone} alt="microphone" className={styles.microphone} /> */}
        </div>
      </div>
      <div>
        {/* <h1>Our Clients</h1>
                <p>JumboMedia dominates the Israeli TV advertising market with hundreds of companies using our system. It is used by all TV channels and broadcasters, as well as most post-production companies and advertisers.</p>
                <div>
                    <img src={customer1} alt="customer1" className={styles.customer1} />
                    <img src={customer2} alt="customer2" className={styles.customer2} />
                    <img src={customer3} alt="customer3" className={styles.customer3} />
                    <img src={customer4} alt="customer4" className={styles.customer4} />
                    <img src={customer5} alt="customer5" className={styles.customer5} />
                    <img src={customer6} alt="customer6" className={styles.customer6} />
                </div> */}
      </div>
    </main>
  );
};

export default ContactUsPublic;
